import React from 'react'

export default function TrackerAll() {
  return (
    <div id='TrackerAll' className='ArchiveContainer'>
    <div className='Ann'></div>
    <div className='TrackerScoreContainer'>
      <div className='TrackerScoreRea'>dddd</div>
    </div>
    <div className='TrackerPitch'>
        <div className='TrackerPitchArea'>
          <div id='TrackerBall'></div>
        </div>
    </div>
  </div>
  )
}
